/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=b7a0c0d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b7a0c0d8&lang=stylus"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__